import { objectToFormData } from "../utils";
import Api from "./axios";

export const updateImage = async ({ user_id, user_image }) => {
  return await Api.put(
    `/user/headshot/profile`,
    objectToFormData({ user_image, user_id })
  );
};
